var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3572 5.64C18.6156 6.89879 19.4724 8.50244 19.8195 10.2482C20.1665 11.9939 19.9881 13.8034 19.3068 15.4478C18.6256 17.0921 17.472 18.4976 15.992 19.4864C14.512 20.4752 12.7721 21.0029 10.9922 21.0029C9.21228 21.0029 7.47234 20.4752 5.99236 19.4864C4.51239 18.4976 3.35883 17.0921 2.67756 15.4478C1.99628 13.8034 1.81788 11.9939 2.16491 10.2482C2.51194 8.50244 3.36881 6.89879 4.62719 5.64M10.9972 1V11",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/LogoutIcon.42900833b00cdb8a81b290861f0e1377.svg";
export { ForwardRef as ReactComponent };